import { useState } from "react";
import { Link } from "react-router-dom";
import type { SalesMove } from "@sales-ops-amplify/shared";
import { ChevronDown, ChevronRight } from "lucide-react";

type Props = {
  move: SalesMove;
};

export function SalesMoveEvidenceSection({ move }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <div className="mt-4 border-t border-border pt-3">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center gap-1.5 text-left text-xs font-medium text-muted-foreground hover:text-foreground"
      >
        {open ? <ChevronDown className="h-3.5 w-3.5" /> : <ChevronRight className="h-3.5 w-3.5" />}
        Details and evidence
      </button>
      {open ? (
        <div className="mt-3 space-y-3 text-xs text-muted-foreground">
          {(move.sourceSignals?.length ?? 0) > 0 ? (
            <div>
              <p className="mb-1 font-medium text-foreground">Supporting signals</p>
              <ul className="list-disc space-y-1 pl-4">
                {move.sourceSignals!.map((s) => (
                  <li key={s.id}>{s.label}</li>
                ))}
              </ul>
            </div>
          ) : null}
          {(move.sourceTasks?.length ?? 0) > 0 ? (
            <div>
              <p className="mb-1 font-medium text-foreground">Source tasks</p>
              <ul className="list-disc space-y-1 pl-4">
                {move.sourceTasks!.map((t) => (
                  <li key={t.taskId}>{t.title}</li>
                ))}
              </ul>
            </div>
          ) : null}
          {(move.sourceLinks?.length ?? 0) > 0 ? (
            <div>
              <p className="mb-1 font-medium text-foreground">Links</p>
              <ul className="space-y-1">
                {move.sourceLinks!.map((l) =>
                  l.href.startsWith("http") ? (
                    <li key={l.href}>
                      <a href={l.href} target="_blank" rel="noreferrer" className="text-brand hover:underline">
                        {l.label}
                      </a>
                    </li>
                  ) : (
                    <li key={l.href}>
                      <Link to={l.href} className="text-brand hover:underline">
                        {l.label}
                      </Link>
                    </li>
                  ),
                )}
              </ul>
            </div>
          ) : null}
          {move.ranking.factors.length > 0 ? (
            <div>
              <p className="mb-1 font-medium text-foreground">Why this ranking</p>
              <ul className="list-disc space-y-1 pl-4">
                {move.ranking.factors.map((f) => (
                  <li key={f.key}>
                    {f.label}: {Math.round(f.weight)}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
